export const ScrollToTop = () => {
    window.scrollTo({
        top: 0,
        behavior: "smooth"
    });
}